"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const redux_1 = require("redux");
const react_redux_1 = require("react-redux");
const ReactModal = require("react-modal");
const icons_1 = require("@dialogexe/cw-asset-provider/icons");
const userProfile_1 = require("@dialogexe/cw-website-store/userProfile");
const images_1 = require("@dialogexe/cw-asset-provider/images");
class Login extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            userName: "",
            email: "",
            password: "",
            confirmPassword: "",
            isOpen: true,
            display: "login"
        };
        this.componentDidUpdate = () => {
            if (this.state.isOpen && this.props.userProfile.userProfile && this.props.userProfile.userProfile.Token) {
                this.setState({ isOpen: false });
            }
        };
        this.handleClose = () => {
            this.props.onClose();
        };
        this.handleLogin = () => {
            const { email, password } = this.state;
            this.props.onSubmit(email, password);
        };
        this.handleChangeEmail = (e) => {
            this.setState({ email: e.target.value });
        };
        this.handleChangePassword = (e) => {
            this.setState({ password: e.target.value });
        };
        this.showCreateNewUserForm = () => {
            this.setState({ display: "newUser" });
            this.props.createNewUserAction.deleteLoginFailedError();
        };
        this.showForgotPasswordForm = () => {
            this.setState({ display: "forgotPassword" });
        };
        this.handleChangeUserName = (e) => {
            this.setState({ userName: e.target.value });
        };
        this.handleCreateNewUser = () => {
            this.props.createNewUserAction.createUser(this.state.email, this.state.userName, this.state.password);
        };
        this.showLoginModal = () => {
            this.setState({ display: "login" });
            this.props.createNewUserAction.deleteLoginFailedError();
        };
        this.handleForgotPassword = () => {
            const { email } = this.state;
            this.props.onForgotPassword(email);
        };
    }
    render() {
        const { error } = this.props.userProfile;
        return (React.createElement(ReactModal, { isOpen: this.state.isOpen, contentLabel: "Minimal Modal Example", ariaHideApp: false, className: "login-modal", overlayClassName: "login-modal-overlay", portalClassName: "login-modal-portal", shouldCloseOnEsc: true, shouldCloseOnOverlayClick: true, onRequestClose: this.props.onRequestClose },
            this.state.display === "login" && React.createElement("div", { className: "login" },
                React.createElement("div", { className: "login login-header" },
                    React.createElement("div", null, " Logg inn"),
                    React.createElement("div", { onClick: this.handleClose, className: "close-icon" },
                        React.createElement("img", { src: icons_1.closeBlackIcon, alt: "" }))),
                React.createElement("div", { className: "login login-body" },
                    React.createElement("div", { className: "info" },
                        React.createElement("div", null, " Logg deg inn med profil fra appen "),
                        React.createElement("div", null, " for \u00E5 se din filmliste, dine billetter og legge til filmer du er interessert i. ")),
                    React.createElement("div", { className: "login-body" },
                        React.createElement("input", { type: "text", placeholder: "Epost", name: "email", onChange: this.handleChangeEmail }),
                        React.createElement("input", { type: "password", placeholder: "Passord", name: "password", onChange: this.handleChangePassword }))),
                error &&
                    React.createElement("div", { className: "login login-fail" },
                        " ",
                        error.data,
                        " "),
                React.createElement("div", { className: "login login-action" },
                    React.createElement("button", { onClick: this.handleLogin, className: "login-button" }, " Logg inn")),
                React.createElement("div", { className: "login login-link-action" },
                    React.createElement("div", { className: "link-wrapper", onClick: this.showCreateNewUserForm }, " Lag ny bruker"),
                    React.createElement("div", { className: "link-wrapper", onClick: this.showForgotPasswordForm }, " Glemt passord?"))),
            this.state.display === "newUser" &&
                React.createElement("div", { className: "new-user" },
                    React.createElement("div", { className: "new-user new-user-header" },
                        React.createElement("div", null, " Lag ny bruker "),
                        React.createElement("div", { onClick: this.handleClose, className: "close-icon" },
                            React.createElement("img", { src: icons_1.closeBlackIcon, alt: "" }))),
                    React.createElement("div", { className: "new-user new-user-body" },
                        React.createElement("div", { className: "new-user-body is-visible-mobile" },
                            React.createElement("div", null, "Hold deg oppdatert med v\u00E5r app"),
                            React.createElement("div", null, "Last ned v\u00E5r app for \u00E5 opprette ny bruker. I appen kan du enkelt legge til filmer du er interessert i, lese anmeldelser og mye mer."),
                            React.createElement("div", { className: "logo" },
                                React.createElement("a", { href: "https://fredrikstad-kino.app.link" },
                                    React.createElement("img", { src: images_1.fredrikstadkinoImage, alt: "fredrikstadkino-logo" })))),
                        React.createElement("div", { className: "new-user-body is-visible-tablet" },
                            React.createElement("div", null, "Hold deg oppdatert med v\u00E5r app"),
                            React.createElement("div", null, "Last ned v\u00E5r app for \u00E5 opprette ny bruker. I appen kan du enkelt legge til filmer du er interessert i, lese anmeldelser og mye mer."),
                            React.createElement("div", { className: "logo" },
                                React.createElement("a", { href: "https://fredrikstad-kino.app.link" },
                                    React.createElement("img", { src: images_1.fredrikstadkinoImage, alt: "fredrikstadkino-logo" })))),
                        React.createElement("div", { className: "new-user-body is-visible-desktop" },
                            React.createElement("div", null, "Hold deg oppdatert med v\u00E5r app"),
                            React.createElement("div", null, "Last ned v\u00E5r mobil-app for \u00E5 opprette ny bruker. I appen kan du enkelt legge til filmer du er interessert i, lese anmeldelser og mye mer."))),
                    React.createElement("div", { className: "new-user new-user-link-action" },
                        React.createElement("a", { className: "link-wrapper", href: "#", onClick: this.showLoginModal }, " Logg inn med eksisterende bruker "))),
            this.state.display === "forgotPassword" && React.createElement("div", { className: "forgot-password" },
                React.createElement("div", { className: "forgot-password forgot-password-header" },
                    React.createElement("div", null, " Glemt passord "),
                    React.createElement("div", { onClick: this.handleClose, className: "close-icon" },
                        React.createElement("img", { src: icons_1.closeBlackIcon, alt: "" }))),
                React.createElement("div", { className: "forgot-password forgot-password-body" },
                    React.createElement("div", { className: "forgot-password-body" },
                        React.createElement("input", { type: "text", placeholder: "Epost", name: "email", onChange: this.handleChangeEmail }))),
                error &&
                    React.createElement("div", { className: "forgot-password forgot-password-fail" },
                        " ",
                        error.data,
                        " "),
                React.createElement("div", { className: "forgot-password forgot-password-action" },
                    React.createElement("button", { onClick: this.handleForgotPassword, className: "forgot-password-button" }, " Send inn")),
                React.createElement("div", { className: "forgot-password forgot-password-link-action" },
                    React.createElement("a", { className: "link-wrapper", href: "#", onClick: this.showLoginModal }, " Logg inn med eksisterende bruker ")))));
    }
}
exports.Login = Login;
exports.default = react_redux_1.connect((state) => ({
    userProfile: state.userProfile
}), (dispatch) => ({
    createNewUserAction: redux_1.bindActionCreators(userProfile_1.actionCreators, dispatch),
}))(Login);



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-authentication/Login.tsx